import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    flex: '1 1 auto',
    /* tabs make this block stretch */
    minWidth: 0,
    display: 'flex',
    flexFlow: 'column nowrap',
    background: theme.palette.white,
  },
}))

export default useStyles
